<template>
  <BaseStickyHeader static-header-class="block-container">
    <div class="block-container py-4 border-b w-full bg-platform-bg-1 z-10">
      <div class="site-viewport-container flex items-center justify-end">
        <div class="mr-auto uppercase">
          <slot name="title" />
        </div>

        <slot name="filter" />
      </div>
    </div>
  </BaseStickyHeader>
</template>
